import Vue from 'vue'
import vTooltip from 'v-tooltip'

Vue.use(vTooltip)

export default vTooltip
